const shim = (w?: number, h?: number) => {
  return `<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#e8e8e8" offset="20%"></stop>
      <stop stop-color="#D3D3D3" offset="50%"></stop>
      <stop stop-color="#e8e8e8" offset="70%"></stop>
    </linearGradient>
  </defs>
      <rect width="${w}" height="${h}" fill="#e8e8e8"></rect>
  <rect id="r" width="${w}" height="${h}" fill="url(#g)"></rect>
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"></animate>
</svg>`;
};

export default shim;
